/**
 * Kurulum kilidi — paylaşılan kurallar.
 *
 * "Kilitteyken hangi yollar açık" listesi App.tsx ve Kabuk.tsx'te iki kopyaydı;
 * biri değişince diğeri unutulur, menüde görünen bir bağlantı tıklanınca geri
 * atar. Tek liste, tek yardımcı.
 */

import type { KurulumAdimi } from './api';

/** Kurulum kilidi açıkken bile gidilebilen yollar: eksiği düzeltmek için gerekenler. */
const KILITTE_ACIK_YOLLAR: readonly string[] = ['/kurulum', '/ayarlar'];

export function kilitteAcikMi(pathname: string): boolean {
  return KILITTE_ACIK_YOLLAR.some((yol) => pathname === yol || pathname.startsWith(`${yol}/`));
}

/** Fatura kesimini DURDURAN eksik adım sayısı. */
export function engelSayisi(adimlar: readonly KurulumAdimi[]): number {
  return adimlar.filter((a) => a.engel && a.durum === 'eksik').length;
}

/** Fatura kesilir ama eksik kalan adım sayısı (Shopify, mail/SMS). */
export function uyariSayisi(adimlar: readonly KurulumAdimi[]): number {
  return adimlar.filter((a) => a.durum === 'uyari').length;
}
